export const POSTING_EVENT_TYPES = [
  { value: "CLIENT_PAYMENT_MATCHED", label: "Client Payment Matched" },
  { value: "DN_PAYMENT_CONFIRMED", label: "Debit Note Payment Confirmed" },
  { value: "GI_SETTLEMENT_CONFIRMED", label: "GI Settlement Confirmed" },
  { value: "COMMISSION_STATEMENT_CONFIRMED", label: "Commission Statement Confirmed" },
  { value: "COMMISSION_BANK_DEPOSIT", label: "Commission Bank Deposit" },
  { value: "PAYROLL_BID_GENERATED", label: "Payroll Bid Generated" },
  { value: "PAYROLL_SETTLED", label: "Payroll Settled" },
  { value: "CREDIT_NOTE_SETTLED", label: "Credit Note Settled" },
  { value: "CLIENT_CREDIT_DEPOSIT", label: "Client Credit Deposit" },
  { value: "CLIENT_CREDIT_APPLIED", label: "Client Credit Applied" },
  { value: "MANUAL_ADJUSTMENT", label: "Manual Adjustment" },
  { value: "OPENING_BALANCE", label: "Opening Balance" },
  { value: "PROFITS_TAX_PROVISION", label: "Profits Tax Provision" },
];
